<div class="kr-transaction-details__header">
  <h4
    class="kr-transaction-details__header-text"
    translate="transactionDetails.title"></h4>

  <button
    class="kr-transaction-details__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="close()">
    <fu-icon iconName="close-square" />
  </button>
</div>

<div class="kr-transaction-details__body">
  <div class="kr-transaction-details__content">
    <section class="kr-transaction-details__content-row">
      <div class="kr-details">
        <label
          class="kr-details__label"
          translate="transactionDetails.label.date">
        </label>

        <span class="kr-details__value">
          {{ transaction.created | date: 'dd.MM.yy' }}
        </span>
      </div>

      <div class="kr-details">
        <label
          class="kr-details__label"
          translate="transactionDetails.label.time">
        </label>

        <span class="kr-details__value">
          {{ transaction.created | date: 'HH:mm:ss' }}
        </span>
      </div>

      <div class="kr-details">
        <label
          class="kr-details__label"
          translate="transactionDetails.label.status">
        </label>

        @if (transaction.statusOriginal) {
          <div class="kr-details__value">
            <kr-status
              [type]="transaction.statusOriginal"
              i18nPrefix="dictionary.transactionStatuses" />
          </div>
        }
      </div>
    </section>

    <section class="kr-transaction-details__content-row">
      <div class="kr-details">
        <label
          class="kr-details__label"
          translate="transactionDetails.label.from">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          (click)="clipboard.copy(transaction.fromWallet)">
          {{ transaction.fromWallet }}
          <fu-icon iconName="copy" size="16" />
        </span>
      </div>
    </section>

    <section class="kr-transaction-details__content-row">
      <div class="kr-details">
        <label
          class="kr-details__label"
          translate="transactionDetails.label.to">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          (click)="clipboard.copy(transaction.toWallet)">
          {{ transaction.toWallet }}
          <fu-icon iconName="copy" size="16" />
        </span>
      </div>
    </section>

    <section
      class="kr-transaction-details__content-row kr-transaction-details__content-row--custom">
      @if (transaction.coin) {
        <div class="kr-details">
          <label
            class="kr-details__label"
            translate="transactionDetails.label.currency">
          </label>

          <span class="kr-details__value">
            {{ transaction.coin.name }}
          </span>
        </div>
      }

      <div class="kr-details">
        <label
          class="kr-details__label"
          translate="transactionDetails.label.amount">
        </label>

        <span
          class="kr-details__value"
          [title]="
            transaction.amount
              | balanceFormat: transaction.coin?.displayName
              | withDigitGroups
          ">
          {{
            transaction.amount
              | balanceFormat: transaction.coin?.displayName
              | withDigitGroups
          }}
        </span>
      </div>

      <div class="kr-details">
        <label class="kr-details__label">
          {{ 'transactionDetails.label.networkFee' | translate }}
          ({{ coinDisplayName }})
        </label>

        <span
          class="kr-details__value"
          [title]="
            transaction.network_fee_amount | balanceFormat: coinDisplayName
          ">
          {{ transaction.network_fee_amount | balanceFormat: coinDisplayName }}
        </span>
      </div>

      <div class="kr-details">
        <label class="kr-details__label">
          {{ 'transactionDetails.label.processingFee' | translate }}
          {{ transaction.coin ? '(' + transaction.coin.displayName + ')' : '' }}
        </label>

        <span
          class="kr-details__value"
          [title]="
            transaction.process_fee_amount
              | balanceFormat: transaction.coin?.displayName
          ">
          {{
            transaction.process_fee_amount
              | balanceFormat: transaction.coin?.displayName
          }}
        </span>
      </div>
    </section>

    @if (transaction.tx) {
      <section class="kr-transaction-details__content-row">
        <div class="kr-details">
          <label
            class="kr-details__label"
            translate="transactionDetails.label.hash">
          </label>

          <span class="kr-details__value kr-details__value_hover">
            @if (transaction.scanUrl) {
              <a [href]="transaction.scanUrl" target="_blank">{{
                transaction.tx
              }}</a>
            } @else {
              {{ transaction.tx }}
            }
            <fu-icon
              (click)="clipboard.copy(transaction.tx)"
              iconName="copy"
              size="16">
            </fu-icon>
          </span>
        </div>
      </section>
    }

    @if (transaction.warnings) {
      <section class="kr-transaction-details__content-row">
        <div class="kr-details">
          <label
            class="kr-details__label"
            translate="transactions.column.substatus">
          </label>

          <span class="kr-details__value">
            <fu-icon iconName="failed" />
            {{ transaction.warnings }}
          </span>
        </div>
      </section>
    }

    @if (transaction.comment) {
      <section class="kr-transaction-details__content-row">
        <div class="kr-details">
          <label
            class="kr-details__label"
            translate="transactionDetails.label.comment">
          </label>

          <span class="kr-details__value">
            {{ transaction.comment }}
          </span>
        </div>
      </section>
    }
  </div>
</div>
